import Swiper from 'swiper';
import 'swiper/css/bundle';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".swiper--home")) {
        new Swiper(".swiper--home", {
            modules: [Autoplay, Navigation, Pagination],
            loop: true,
            autoHeight: true,
            slidesPerView: 1,
            speed: 1200,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper--home__pagination',
                type: 'bullets',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    }

    if (document.querySelector(".swiper--partners")) {
        new Swiper(".swiper--partners", {
            modules: [Autoplay, Pagination],
            loop: true,
            spaceBetween: 20,
            autoHeight: true,
            slidesPerView: 3,
            speed: 800,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper--partners__pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                1024: {
                    slidesPerView: 6,
                },
            },
        });
    }
});